import store_rendez_vous from '@/store/mods/clinique/rendez_vous'
import store_patient from '@/store/mods/clinique/patients'
import ManagePatientModal from '@/components/dashboard/liste-patients/manage-patient'
import $ from 'jquery'
import { aujourdhui, jour_local, jour_rdv, prochaine_demi_heure, date_lisible, date_rdv_lisible, est_heure_a_fixer, message_erreur } from '@/utils/rendez-vous'

// RDV-002 : fenêtre de prise de rendez-vous (Accueil, Caisse) pour un patient existant, ou de reprogrammation d'un
// rendez-vous planifié. Spécialité puis médecin habilité (référentiel de la Clinique et annuaire de be_config), date et
// heure libres en heure locale, motif. Les conflits renvoyés par la Clinique sont affichés, jamais bloquants.
// RDV-006 : à l'Accueil l'heure reste obligatoire ; un rendez-vous « heure à fixer » s'affiche sans 00:00 et, reprogrammé,
// propose son jour.
// C8 : ouverte sans patient (bouton « Prendre un rendez-vous » de l'agenda), la fenêtre fait d'abord rechercher le
// patient (nom, dossier ou téléphone) dans la liste des patients de la Clinique.
export default {
    name: 'prise-rendez-vous',
    components: { ManagePatientModal },
    props: {
        patient_id: { type: Number, default: 0 },
        patient_nom: { type: String, default: '' },
        rendez_vous: { type: Object, default: null },   // rendez-vous à reprogrammer (null : nouveau rendez-vous)
        toggler: { type: Number, default: 0 }
    },
    data() {
        return {
            modal: false, is_loading: false, is_saving: false, erreur: '', erreur_form: '',
            annuaire: [], referentiel: null,
            form: { type_consultation_id: '', medecin_id: '', date: '', heure: '', motif: '', commentaire: '' },
            resultat: null, sequence: 0, detruit: false,
            patient_choisi: null, recherche_patient: '', patients_trouves: [], patients_loading: false, patients_erreur: '', patients_sequence: 0, patients_timer: null,
            creation_toggler: 0, creation_en_attente: false, creation_ouverte: false
        }
    },

    watch: {
        toggler() {
            this.ouvrir()
        }
    },

    computed: {
        reprogrammation() {
            return !!(this.rendez_vous && this.rendez_vous.rendez_vous_id)
        },

        titre() {
            return this.reprogrammation ? 'Reprogrammer le rendez-vous' : 'Programmer un rendez-vous'
        },

        // Nouveau rendez-vous sans patient désigné : l'Accueil choisit le patient dans la fenêtre
        choix_patient() {
            return !this.reprogrammation && !(Number(this.patient_id) > 0)
        },

        patient_final() {
            if (!this.choix_patient) return this.patient_id
            return this.patient_choisi ? this.patient_choisi.id : 0
        },

        types() {
            return this.referentiel && Array.isArray(this.referentiel.types_consultations) ? this.referentiel.types_consultations : []
        },

        // Médecins habilités pour la spécialité choisie ; sans habilitation connue, tout l'annuaire
        medecins_proposes() {
            const carte = this.referentiel && this.referentiel.medecins_par_type && typeof this.referentiel.medecins_par_type === 'object' ? this.referentiel.medecins_par_type : {}
            const cle = String(this.form.type_consultation_id)
            const habilites = this.form.type_consultation_id && Array.isArray(carte[cle]) ? carte[cle].map(Number) : null
            if (!habilites || !habilites.length) return this.annuaire
            return this.annuaire.filter(medecin => habilites.indexOf(Number(medecin.id)) !== -1)
        },

        medecin_choisi() {
            return this.annuaire.filter(medecin => Number(medecin.id) === Number(this.form.medecin_id))[0] || null
        },

        date_min() {
            return aujourdhui()
        },

        conflits() {
            return this.resultat && Array.isArray(this.resultat.conflits) ? this.resultat.conflits : []
        }
    },

    mounted() {
        if (this.$refs.creationPatient) $(this.$refs.creationPatient.$el).on('hidden.bs.modal', this.retour_formulaire_patient)
    },

    beforeDestroy() {
        this.detruit = true
        this.sequence++
        this.patients_sequence++
        clearTimeout(this.patients_timer)
        if (this.$refs.creationPatient) $(this.$refs.creationPatient.$el).off('hidden.bs.modal', this.retour_formulaire_patient)
    },

    methods: {
        ouvrir() {
            const defaut = prochaine_demi_heure()
            this.resultat = null
            this.erreur = ''
            this.erreur_form = ''
            this.reinitialiser_patient()
            this.creation_en_attente = false
            this.form = {
                type_consultation_id: this.reprogrammation && this.rendez_vous.type_consultation_id ? String(this.rendez_vous.type_consultation_id) : '',
                medecin_id: this.reprogrammation && this.rendez_vous.medecin_id ? String(this.rendez_vous.medecin_id) : '',
                date: defaut.date, heure: defaut.heure, motif: '', commentaire: ''
            }
            // RDV-006 : un rendez-vous dont l'heure est à fixer garde son jour s'il n'est pas passé
            const jour = this.reprogrammation && est_heure_a_fixer(this.rendez_vous) ? jour_rdv(this.rendez_vous) : ''
            if (jour && jour > this.form.date) this.form.date = jour
            this.modal = true
            return this.charger()
        },

        charger() {
            if (this.detruit) return Promise.resolve()
            const sequence = ++this.sequence
            this.is_loading = true
            this.erreur = ''
            return Promise.all([store_rendez_vous.getAcces(), store_rendez_vous.getReferentiel()]).then((reponses) => {
                if (this.detruit || sequence !== this.sequence) return
                this.annuaire = reponses[0] && Array.isArray(reponses[0].medecins) ? reponses[0].medecins : []
                this.referentiel = reponses[1] && reponses[1].success && reponses[1].data ? reponses[1].data : null
                this.is_loading = false
            }).catch((error) => {
                if (this.detruit || sequence !== this.sequence) return
                this.is_loading = false
                this.erreur = message_erreur(error, 'Impossible de préparer la prise de rendez-vous (accès ou référentiel indisponible).')
            })
        },

        reinitialiser_patient() {
            clearTimeout(this.patients_timer)
            this.patients_sequence++
            this.patient_choisi = null
            this.recherche_patient = ''
            this.patients_trouves = []
            this.patients_loading = false
            this.patients_erreur = ''
        },

        // Recherche du patient (au moins 2 caractères, 300 ms après la frappe)
        chercher_patient() {
            clearTimeout(this.patients_timer)
            this.patients_sequence++
            this.patients_erreur = ''
            if (this.recherche_patient.trim().length < 2) {
                this.patients_trouves = []
                this.patients_loading = false
                return
            }
            this.patients_loading = true
            this.patients_timer = setTimeout(() => { this.rechercher_patients() }, 300)
        },

        rechercher_patients() {
            clearTimeout(this.patients_timer)
            const terme = this.recherche_patient.trim()
            if (this.detruit || terme.length < 2) return Promise.resolve()
            const sequence = ++this.patients_sequence
            this.patients_loading = true
            this.patients_erreur = ''
            return store_patient.getListeAllPatient({ search_term: terme, page: 1, with_consultation: false }).then((reponse) => {
                if (this.detruit || sequence !== this.patients_sequence) return
                const liste = reponse && Array.isArray(reponse.data) ? reponse.data : []
                this.patients_trouves = liste.map(patient => ({
                    id: Number(patient.patient_id) || 0, nom: patient.patient_nom || 'Patient', dossier: patient.patient_code || '',
                    telephone: patient.patient_telephone || '', sexe: patient.sexe || '', age: patient.age || ''
                })).filter(patient => patient.id > 0).slice(0, 8)
                this.patients_loading = false
            }).catch((error) => {
                if (this.detruit || sequence !== this.patients_sequence) return
                this.patients_trouves = []
                this.patients_loading = false
                this.patients_erreur = message_erreur(error, 'La recherche des patients a échoué.')
            })
        },

        choisir_patient(patient) {
            if (!patient || !(Number(patient.id) > 0)) return
            clearTimeout(this.patients_timer)
            this.patients_sequence++
            this.patients_loading = false
            this.patient_choisi = patient
            this.erreur_form = ''
        },

        changer_patient() {
            this.patient_choisi = null
        },
        ouvrir_formulaire_patient() {
            if (this.is_saving || !this.choix_patient) return
            this.creation_en_attente = true
            this.modal = false
        },
        patient_cree(patient) {
            if (!patient || !(Number(patient.id) > 0)) return
            this.choisir_patient({ id: Number(patient.id), nom: [patient.nom, patient.prenoms].filter(Boolean).join(' '), dossier: patient.code || '', telephone: patient.telephone_mobile || '' })
            if (this.$refs.creationPatient) $(this.$refs.creationPatient.$el).modal('hide')
        },
        retour_formulaire_patient() {
            if (!this.creation_ouverte || this.detruit) return
            this.creation_ouverte = false
            this.modal = true
        },

        changer_type() {
            if (this.form.medecin_id && !this.medecins_proposes.some(medecin => Number(medecin.id) === Number(this.form.medecin_id))) this.form.medecin_id = ''
        },

        // Heure locale du poste « AAAA-MM-JJ HH:MM » pour refuser un rendez-vous déjà passé avant l'appel
        maintenant_local() {
            const d = new Date(), deux = n => (n < 10 ? '0' : '') + n
            return jour_local(d) + ' ' + deux(d.getHours()) + ':' + deux(d.getMinutes())
        },

        valider() {
            if (this.choix_patient && !this.patient_choisi) return 'Choisissez le patient ou créez un nouveau dossier.'
            if (!this.reprogrammation && !this.form.medecin_id) return 'Choisissez le médecin du rendez-vous.'
            if (!/^\d{4}-\d{2}-\d{2}$/.test(this.form.date)) return 'Indiquez la date du rendez-vous.'
            if (!/^\d{2}:\d{2}$/.test(this.form.heure)) return 'Indiquez l\'heure du rendez-vous.'
            if (this.form.date + ' ' + this.form.heure <= this.maintenant_local()) return 'Le rendez-vous doit être à venir.'
            return ''
        },

        date_heure() {
            return this.form.date + 'T' + this.form.heure
        },

        payload() {
            if (this.reprogrammation) return { date_heure: this.date_heure(), motif: this.form.motif.trim() ? this.form.motif.trim() : null }
            return {
                patient_id: this.patient_final, medecin_id: Number(this.form.medecin_id), medecin_nom: this.medecin_choisi ? this.medecin_choisi.nom : null,
                type_consultation_id: this.form.type_consultation_id ? Number(this.form.type_consultation_id) : null,
                date_heure: this.date_heure(), motif: this.form.motif.trim() ? this.form.motif.trim() : null, commentaire: this.form.commentaire.trim() ? this.form.commentaire.trim() : null
            }
        },

        async enregistrer() {
            if (this.is_saving) return Promise.resolve()
            const erreur = this.valider()
            if (erreur) {
                this.erreur_form = erreur
                return Promise.resolve()
            }
            this.is_saving = true
            this.erreur_form = ''
            try {
                const response = await (this.reprogrammation ? store_rendez_vous.reprogrammer(this.rendez_vous.rendez_vous_id, this.payload()) : store_rendez_vous.creerRendezVous(this.payload()))
                if (this.detruit) return
                if (!response || response.success !== true) throw new Error('Enregistrement refusé')
                this.is_saving = false
                this.resultat = response
            } catch (error) {
                if (this.detruit) return
                this.is_saving = false
                this.erreur_form = (this.patient_choisi && this.choix_patient ? 'Dossier patient conservé. ' : '') + message_erreur(error, error && error.message ? error.message : 'Le rendez-vous n\'a pas été enregistré. Réessayez.')
            }
        },

        fermer() {
            this.modal = false
        },

        // À la fermeture, le parent est prévenu si un rendez-vous a été enregistré (bouton Fermer ou croix)
        apres_fermeture() {
            if (this.creation_en_attente) {
                this.creation_en_attente = false
                this.creation_ouverte = true
                this.creation_toggler++
                this.$nextTick(() => { if (this.$refs.creationPatient) $(this.$refs.creationPatient.$el).modal('show') })
                return
            }
            const resultat = this.resultat
            this.resultat = null
            if (resultat) this.$emit('emitRendezVousEnregistre', resultat)
        },

        date_heure_lisible(valeur) {
            return date_lisible(valeur)
        },

        // « 25/09/2026 09:30 », ou « jeudi 01/10/2026 · heure à fixer »
        date_rdv(ligne) {
            return date_rdv_lisible(ligne)
        }
    }
}
